// @flow strict

/* eslint-disable ta-code-conventions/has-matching-test */

import * as React from 'react';
import IsVisible from './IsVisible';

type Props = {|
  /** Callback that will be activated the first time the WebComponent becomes visible */
  onIsVisibleCallback: () => void,

  /** Any WebComponent(s) that needs to alert once it becomes visible. */
  +children: React.Node,

  /** A number to specify a pixel-count fuzz-factor for determining visibility */
  +threshold: number,

  /** if your element is hidden (has not yet loaded then it will never be visible).
   * Set this to true to give the wrapping element some dimensions that will be used
   * instead when figuring out if we have been seen. The wrapper is removed once
   * we are considered visible.
   */
  +makeWrapperHaveDimensions: boolean,
|};

type State = {|
  seen: boolean,
|};

/**
 * Provides the boiler plate around IsVisible such that once the component is visible IsVisible is removed
 * from the heirarchy. Useful when you only need to be alerted the first time your component becomes visible
 * and don't need it any other times.
 */
export default class IsVisibleOnce extends React.Component<Props, State> {
  static defaultProps = {
    threshold: 0,
    makeWrapperHaveDimensions: false,
  };

  state = {
    seen: false,
  };

  render() {
    const wrappingStyles = this.props.makeWrapperHaveDimensions
      ? { minWidth: '1px', minHeight: '1px' }
      : {};

    return (
      <IsVisible
        threshold={this.props.threshold}
        disableListeners={this.state.seen}
        onChange={isVisible => {
          if (isVisible) {
            this.setState({ seen: true });
            this.props.onIsVisibleCallback();
          }
        }}
      >
        {target => (
          <div key="isVisibleOnce" style={wrappingStyles} ref={target}>
            {this.props.children}
          </div>
        )}
      </IsVisible>
    );
  }
}
